import React from "react";
import { PurchaseHistoryModal } from "./PurchaseHistoryModal";

export const PurchaseHistoryButton = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <div
        onClick={() => setIsOpen(true)}
        className="btnGray100 min-h-11 h-11 rounded-full cursor-pointer"
      >
        Purchase history
      </div>

      <PurchaseHistoryModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
